import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Button } from 'redpoints-front-components/index';

import {
  auditResultsClearFilters,
  auditResultsFetchCompletedAudit,
  auditResultsSetAppliedAuditorAssetId,
} from '../../../actions/auditResultsActions';
import {
  getAuditResultsAppliedAuditorAssetId,
  getAuditResultsCompletedAuditIsLoading,
  getAuditResultsIsCompletedAudit,
  getAuditResultsIsLoading,
  getAuditResultsSelectedAuditorAssetId,
} from '../../../reducers/assetAudit/auditResults';
import AuditResultsSaveAuditModal from './AuditResultsSaveAuditModal';
import { translate } from '../../../helpers/languageHelper';

const AuditResultsFiltersActions = ({
  appliedAuditorAssetId,
  auditResultsClearFilters,
  auditResultsFetchCompletedAudit,
  auditResultsSetAppliedAuditorAssetId,
  isAuditResultsCompleted,
  isLoadingAuditResults,
  isLoadingAuditResultsCompleted,
  selectedAuditorAssetId,
}) => {
  const [showSaveModal, setShowSaveModal] = useState(false);
  const shouldDisableFiltersActionButtons =
    !selectedAuditorAssetId ||
    isLoadingAuditResultsCompleted ||
    isLoadingAuditResults;

  useEffect(() => {
    const hasFetchedAuditResultsCompleted =
      isAuditResultsCompleted != null && !isLoadingAuditResultsCompleted;

    if (hasFetchedAuditResultsCompleted) {
      if (isAuditResultsCompleted) {
        auditResultsSetAppliedAuditorAssetId({
          assetId: selectedAuditorAssetId,
        });
      } else {
        setShowSaveModal(true);
      }
    }
  }, [
    auditResultsSetAppliedAuditorAssetId,
    isAuditResultsCompleted,
    isLoadingAuditResultsCompleted,
    selectedAuditorAssetId,
  ]);

  const handleCloseSaveModal = () => {
    setShowSaveModal(false);
  };

  const handleOnApplyClick = () => {
    auditResultsFetchCompletedAudit({
      auditAssetId: selectedAuditorAssetId,
    });
  };

  const handleOnCancelClick = () => {
    auditResultsClearFilters();
  };

  return (
    <div className="audit-results-filters-actions">
      <Button
        className="ant-btn-sm"
        disabled={shouldDisableFiltersActionButtons}
        onClick={handleOnApplyClick}
        type="primary"
      >
        {translate('actions.apply')}
      </Button>
      <Button
        className="ant-btn-sm"
        disabled={shouldDisableFiltersActionButtons}
        onClick={handleOnCancelClick}
        type="secondary"
      >
        {translate('actions.clear')}
      </Button>
      <AuditResultsSaveAuditModal
        auditAssetId={appliedAuditorAssetId}
        closeModal={handleCloseSaveModal}
        visible={showSaveModal}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  appliedAuditorAssetId: getAuditResultsAppliedAuditorAssetId(state),
  isAuditResultsCompleted: getAuditResultsIsCompletedAudit(state),
  isLoadingAuditResults: getAuditResultsIsLoading(state),
  isLoadingAuditResultsCompleted: getAuditResultsCompletedAuditIsLoading(state),
  selectedAuditorAssetId: getAuditResultsSelectedAuditorAssetId(state),
});

export default connect(mapStateToProps, {
  auditResultsClearFilters,
  auditResultsFetchCompletedAudit,
  auditResultsSetAppliedAuditorAssetId,
})(AuditResultsFiltersActions);
